export default "__VITE_ASSET__DMh1KNBB__"